import { Component, signal } from '@angular/core';
import { ContractStatus } from '../../../store/contract/types';
import { filter, take } from 'rxjs/operators';
import { DocumentService } from '../../../store/document/document.service';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-document-link',
  standalone: false,
  templateUrl: './document-link.component.html',
  styleUrl: './document-link.component.scss',
})
export class DocumentLinkComponent implements ICellRendererAngularComp {
  readonly documentId = signal<number | null>(null);
  private data: any;

  constructor(private readonly documentService: DocumentService) {}

  agInit(params: ICellRendererParams): void {
    this.refresh(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.documentId.set(params.value);
    return true;
  }

  onClickShowDocument(event: Event) {
    event.stopPropagation();

    const documentId = this.documentId();

    if (documentId === null || documentId <= 0) return;

    const getFileSubscription = this.documentService.getFile.value$
      .pipe(
        // tap((x) => {
        //   console.log(x);
        // }),
        filter((x) => !!x),
        take(1),
      )
      .subscribe((result: Blob) => {
        var fileURL = window.URL.createObjectURL(result);
        let tab = window.open();
        if (tab) {
          tab.location.href = fileURL;
        }
        this.documentService.getFile.reset();
      });

    this.documentService.getFile.call(documentId.toString());
  }
}
